















import { listFactory } from '@/main/pages';
import { apiProvider } from '@/modules/ciselnik/firemni/nakladoveStredisko/api';
import { showAlert } from '@/main/utils/notifications';

import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	methods: {
		async editClick(event: any) {
			const { data: canEdit } = await apiProvider.IsCostCenterAlreadyUsed(event.data.ZAZNAM_ID);
			if (canEdit) {
				openEdit(NAME, PageMode.EDIT, { id: event.data.ZAZNAM_ID });
			}
			else {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
		},
	},
});


